// BuildingStabilityInfoComponent.js
import { useEffect, useState } from "react";
import { SectionHeader, EditableInputComponent } from "components";
import { Document } from "assets/icons"; // Replace with appropriate icons
import { useSession } from "@clerk/clerk-react";

// Assuming BuildingStabilityInfoDTO is defined elsewhere in your application
import { BuildingDTO } from "shared/types/building";
import { UnitDTO } from "shared/types/unit";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { API_URL } from "constants/index";
import { toast } from "react-toastify";
import { BuildingOwnerShipInfo } from "shared/types/ownership-info";

interface BuildingOwnershipInfoComponentProps {
  ownershipInfo: BuildingOwnerShipInfo;
  handleInspectionInfoChangeInParent?: (value: any) => any;
  handleSaveInParent?: () => any;
  handleCloseParent?: () => any;
  building: BuildingDTO;
  unit: UnitDTO;
  parentEditMode?: boolean;
}

const BuildingInsuranceInfoComponent = ({
  ownershipInfo,
  handleCloseParent,
  parentEditMode = true,
}: BuildingOwnershipInfoComponentProps) => {
  const [editMode, setEditMode] = useState(parentEditMode);
  const [editedInsuranceValue, setEditedInsuranceValue] = useState<number | null>(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const { session } = useSession();

  useEffect(() => {
    setEditedInsuranceValue(ownershipInfo.buildingInsuredValue);
  }, []); // don't use the dependency here because it will refresh the component on tab switch

  const handleSave = async () => {
    setHasUnsavedChanges(false);
    try {
      await fetchWithAuth(
        `${API_URL}/building/building-insurance-value`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            buildingOwnershipInfoId: ownershipInfo?.id,
            insuranceValue: editedInsuranceValue
          }),
        },
        session,
      );
      toast.success("Verzekerings informatie succesvol bijgewerkt!");
    } catch (e) {
      console.error(e);
      toast.error(
        "Er is een fout opgetreden bij het bijwerken van de verzekerings informatie.",
      );
    }
  };

  const getStatusColor = (buildingInsuredValue: any) => {
    if (
      !buildingInsuredValue ||
      buildingInsuredValue == 0 ||
      buildingInsuredValue == ""
    ) {
      return "bg-red-500";
    } else {
      return "bg-green-500";
    }
  };


  return (
    <section className="flex flex-col gap-0 rounded-md bg-white">
      <SectionHeader
        title="Eigendomsinformatie"
        icon={<Document />}
        editMode={editMode}
        sticky={false}
        onEditClick={() => setEditMode(!editMode)}
        onSaveClick={() => handleSave()}
        showEditToggle={true}
        hasUnsavedChanges={hasUnsavedChanges}
        onCloseClick={handleCloseParent}
        hideCloseAction={true}
      />
      <div className="p-6">
        <div className="grid gap-6 md:grid-cols-2">
          {/* Description for PreEmptionRightPresent */}

          <div className="flex flex-col gap-3 rounded-md border border-gray-200 p-4">
            <header className="flex items-center gap-2 text-sm font-medium">
              <span
                className={`inline-block h-5 w-5 rounded-full ${getStatusColor(
                  editedInsuranceValue,
                )}`}
              />
              <p>Verzekerde waarde</p>
            </header>
            <EditableInputComponent
              label="Verzekerde waarde van het gebouw"
              value={editedInsuranceValue?.toString() || ""}
              isLoading={false}
              editMode={editMode}
              onChange={(value) => setEditedInsuranceValue(Number(value))}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuildingInsuranceInfoComponent;
